<template>
	<component
		:is="tag"
		ref="component"
		:class="[
			settings.fixedClasses,
			size ? `nk-title--${size}` : null,
			size ? settings.sizes[size] : null,
			color ? settings.colors[color] : null,
			color ? 'has-color' : null,
			leading ? settings.leadings[leading] : null,
			weight ? settings.weights[weight] : null,
			maxLines ? settings.lineClamps[maxLines] : null,
			groupHover ? `group-hover:${groupHover}` : null,
			groupFocus ? `group-focus:${groupFocus}` : null,
			noMargin ? 'm-0' : null,
			truncate ? 'truncate w-full' : null,
			italic ? 'italic' : null,
		]"
	>
		<span>
			<slot />
		</span>
	</component>
</template>

<script setup>
import {defineSettings} from '../composables/component';
const settings = defineSettings('NkTitle');

defineProps({
	tag: {
		type: String,
		default: 'p',
		required: false,
	},
	size: {
		type: String,
		default: null,
		required: false,
	},
	color: {
		type: String,
		default: null,
		required: false,
	},
	maxLines: {
		type: [Number, String],
		required: false,
		default: null,
	},
	groupHover: {
		type: String,
		default: 'text-current',
		required: false,
	},
	groupFocus: {
		type: String,
		default: 'text-current',
		required: false,
	},
	noMargin: {
		type: Boolean,
		default: false,
		required: false,
	},
	weight: {
		type: String,
		default: null,
		required: false,
	},
	truncate: {
		type: Boolean,
		default: false,
		required: false,
	},
	italic: {
		type: Boolean,
		default: false,
		required: false,
	},
	leading: {
		type: String,
		default: null,
		required: false,
	},
});
</script>
